import { Navigate, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/dashboard/admin/enquiries", label: "Enquiries" },
  { to: "/dashboard/admin/blog", label: "Blog" },
  { to: "/dashboard/admin/vlog", label: "Vlog" },
  { to: "/dashboard/admin/founders", label: "Founders" },
  { to: "/dashboard/admin/classes", label: "Class Schedule" },
  { to: "/dashboard/admin/founding-members", label: "Founding 50" },
];

export default function AdminLayout() {
  const { user } = useAuth();

  if (user?.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div data-testid="admin-content-editor">
      <h1 className="font-anton uppercase tracking-tighter text-cream text-3xl sm:text-4xl mb-6">Content Editor</h1>
      <div className="flex flex-wrap gap-2 border-b border-line mb-8">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `px-4 py-3 text-sm uppercase tracking-wider border-b-2 transition-colors ${
                isActive ? "border-gold text-gold" : "border-transparent text-smoke hover:text-cream"
              }`
            }
            data-testid={`admin-tab-${tab.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
